import Images from "../../constant/Images";

export const UserSearch = ({
  onSearch,
  searchQuery,
}: {
  onSearch: (term: string) => void;
  searchQuery: string;
}) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        const form = e.target as HTMLFormElement;
        const input = form.elements.namedItem("search") as HTMLInputElement;
        onSearch(input.value);
      }}
      className="relative mt-6 flex border border-aqua rounded-3xl items-center justify-center pr-10"
    >
      <img className="ml-2 h-5" src={Images.search} alt="Search icon" />
      <input
        type="search"
        name="search"
        className="w-[538px] p-2 text-sm text-gray-900 border-none rounded-3xl font-roboto font-normal focus:outline-none"
        placeholder="Search users..."
        defaultValue={searchQuery}
      />
    </form>
  );
};
